module.exports = __webpack_public_path__ + "img/123.a768be8f.png";